import { render, staticRenderFns } from "./S3Settings.vue?vue&type=template&id=00795c8f&"
import script from "./S3Settings.vue?vue&type=script&lang=js&"
export * from "./S3Settings.vue?vue&type=script&lang=js&"
import style0 from "./S3Settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00795c8f')) {
      api.createRecord('00795c8f', component.options)
    } else {
      api.reload('00795c8f', component.options)
    }
    module.hot.accept("./S3Settings.vue?vue&type=template&id=00795c8f&", function () {
      api.rerender('00795c8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/S3Settings.vue"
export default component.exports